import { render, staticRenderFns } from "./TopMenuBar.vue?vue&type=template&id=46f4239c&scoped=true"
import script from "./TopMenuBar.vue?vue&type=script&lang=js"
export * from "./TopMenuBar.vue?vue&type=script&lang=js"
import style0 from "./TopMenuBar.vue?vue&type=style&index=0&id=46f4239c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f4239c",
  null
  
)

export default component.exports